<div class="player-wrapper">
    <video #video playsinline autoplay preload="auto"></video>

    <img *ngIf="image" [src]="image" alt="Audio cover" class="audio-cover" />

    <div *ngIf="isLoading" class="loader-overlay">
        <div class="loader"></div>
    </div>

    <div class="controls">
        <button (click)="togglePlay()">
            <ng-container *ngIf="isPlaying; else playIcon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="icon">
                    <rect x="6" y="4" width="4" height="16"></rect>
                    <rect x="14" y="4" width="4" height="16"></rect>
                </svg>
            </ng-container>
            <ng-template #playIcon>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="icon">
                    <polygon points="5 3 19 12 5 21 5 3"></polygon>
                </svg>
            </ng-template>
        </button>

        <input type="range" min="0" max="100" [value]="progress" (input)="seek($event)" />

        <button (click)="toggleMute()">
            <ng-container *ngIf="isMuted; else volumeIcon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="icon">
                    <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>
                    <line x1="23" y1="9" x2="17" y2="15"></line>
                    <line x1="17" y1="9" x2="23" y2="15"></line>
                </svg>
            </ng-container>
            <ng-template #volumeIcon>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="icon">
                    <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>
                    <path d="M19 5a9 9 0 0 1 0 14"></path>
                    <path d="M15 9a5 5 0 0 1 0 6"></path>
                </svg>
            </ng-template>
        </button>

        <button *ngIf="!image" (click)="goFullscreen()">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="icon">
                <path d="M15 3h6v6"></path>
                <path d="M9 21H3v-6"></path>
                <path d="M21 15v6h-6"></path>
                <path d="M3 9V3h6"></path>
            </svg>
        </button>
    </div>
</div>